import { AlertBar2 } from "@/components/UI2/atoms/AlertBar";
import { CosignatureStatusEnum } from "@/core/constants";
import dayjs from "@/lib/helpers/dayjs";
import { Heading2 } from "@/ui2/atoms/Heading";
import { useNoteCosignMeta } from "@/features/cosignature/api/queries/useNoteCosignMeta";
import type { UUID } from "@/core/types";

import { CosignRejectedAlertSkeleton } from "./CosignRejectedAlertSkeleton";

type Props = {
  noteId: UUID;
};

export function CosignRejectedAlert({ noteId }: Props) {
  const { data: meta, isLoading } = useNoteCosignMeta({
    documentId: noteId,
  });

  if (isLoading) return <CosignRejectedAlertSkeleton />;
  if (!meta) return null;

  const isResubmitted = meta.cosignature_status === CosignatureStatusEnum.RESUBMITTED;
  const isRejected = meta.cosignature_status === CosignatureStatusEnum.REJECTED;

  if (!isRejected && !(isResubmitted && meta.rejection_reason)) return null;

  const reviewer = meta.reviewing_supervisor_name ?? "—";
  const date = meta.rejection_date ? dayjs(meta.rejection_date).format("M/D/YYYY, h:mm A") : "—";
  const reason = meta.rejection_reason ?? "—";

  return (
    <AlertBar2 className="tw:flex tw:flex-col tw:gap-3.5" variant="warning">
      <Heading2 className="tw:text-inherit" size={2}>
        {isResubmitted ? "Note resubmitted for review" : "Note co-sign rejected"}
      </Heading2>

      <dl className="tw:grid tw:grid-cols-[auto_1fr] tw:gap-x-6 tw:gap-y-2">
        <dt className="tw:font-semibold">Reviewed By:</dt>
        <dd>
          {reviewer} • {date}
        </dd>

        <dt className="tw:font-semibold">Reasoning:</dt>
        <dd>{reason}</dd>
      </dl>
    </AlertBar2>
  );
}
